exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-comment .timeline-item-main[data-v-9188ca76]{position:relative;background:#f0f0f0;border-radius:.4em;padding:1rem;max-width:50%;margin-bottom:1rem}.user-comment .timeline-item-main[data-v-9188ca76]:after{content:\"\";position:absolute;left:0;top:10%;width:0;height:0;border:22px solid transparent;border-right-color:#f0f0f0;border-left:0;border-top:0;margin-left:-15px;z-index:-1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9188ca76","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Timeline.vue
// module id = G3lb
// module chunks = 1